import { render, staticRenderFns } from "./CategoriesChip.vue?vue&type=template&id=6783095e"
import script from "./CategoriesChip.vue?vue&type=script&lang=js"
export * from "./CategoriesChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports